import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_AIChapterContentGenerator = _resolveComponent("AIChapterContentGenerator");
  return _openBlock(), _createElementBlock("div", null, [_ctx.loadingInterface ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_loader)])) : _createCommentVNode("", true), !_ctx.loadingInterface ? (_openBlock(), _createBlock(_component_AIChapterContentGenerator, {
    key: 1,
    "speach-generated": _ctx.speachGenerated,
    "speach-to-map": _ctx.speachToMap,
    "index-lecon": _ctx.indexLecon,
    "index-chapter": _ctx.indexChapter,
    "weet-endpoint": _ctx.weetEndpoint,
    "ai-files": _ctx.aiFiles,
    language: _ctx.language,
    onOnClose: _ctx.finishEditing
  }, null, 8, ["speach-generated", "speach-to-map", "index-lecon", "index-chapter", "weet-endpoint", "ai-files", "language", "onOnClose"])) : _createCommentVNode("", true)]);
}